/**
 * Wat een drempel is, en wat er niet een is.
 *
 * Een heel getal van minstens één, in de schrijfwijze die beide grenzen erachter aanvaarden
 * (`docs/api-contracts.md`, sectie Werkkwaliteit; `work-quality.routes.ts`, `WHAT_IF_NUMBER`).
 * Cijfers, geen voorloopnul, groter dan nul. Ook het doel gaat hierdoor (story 12): beide velden zijn
 * hele getallen. Het bereik (drempel van het minimum tot en met het maximum van de dienst, begrensd op 20-100; doel 1-100) controleert
 * het formulier zelf (`Instellingformulier.tsx`), en de API nog een keer. Uitgeschreven en niet door `Number()` gehaald: die
 * slikt `" 25"`, `"1e3"`, `"0x19"` en `"25.0"` zonder morren, en dat zijn vier schrijfwijzen die de
 * meting afkeurt. Een portaal dat ze doorlaat, laat een beheerder een afwijzing lezen over een
 * waarde die zij niet getypt heeft.
 *
 * Dit is geen rekenwerk aan een meting (NFR9): het zet de tekst uit één invoerveld om in het getal
 * dat de vraag aan de API wordt. Er komt geen uitkomst uit op het scherm.
 */
const DREMPEL = /^[1-9]\d*$/;

/** Het getal in `tekst`, of `null` zodra het geen heel getal van minstens één is. */
export function leesDrempel(tekst: string): number | null {
  if (!DREMPEL.test(tekst)) return null;
  const getal = Number(tekst);
  return Number.isSafeInteger(getal) ? getal : null;
}

/** De ondergrens van het weekscherm: nooit minder dan 20 producten per werksoort per week (besluit 19-10 #2). */
const MINIMUM_DREMPEL = 20;

/**
 * De drempel die het weekscherm toepast: het hogere van 20 en de drempel die de dienst stuurt. Stuurt de
 * dienst geen heel getal, dan geldt 20 (ux-spec 9.4).
 */
export function effectieveDrempel(waarde: unknown): number {
  return typeof waarde === 'number' && Number.isSafeInteger(waarde) ? Math.max(MINIMUM_DREMPEL, waarde) : MINIMUM_DREMPEL;
}
